import { vuetifyStudioDarkTheme, vuetifyStudioLightTheme } from './themeVuetifyStudio';

const livLightTheme = {
  dark: false,
  colors: {
    ...vuetifyStudioLightTheme.colors,

    'liv-app-bar-bg-color': '#d6e6ff', // SalesForce: --slds-g-color-brand-base-90 (Veiling Waterfalls)
    'liv-app-bar-nav-icon-color': '#0f62fe', // IBM Blue 60
    'liv-app-bar-title-color': '#002d9c', // IBM Blue 80
    'liv-app-bar-avatar-color': '#4589ff', // IBM Blue 50

    // 'liv-footer-bg-color': '#ccd5eb', // Shade of IBM Blue 80
    'liv-footer-bg-color': '#e8eaf6', // Vuetify's Indigo 50
    'liv-footer-text-color': '#000080', // Navy Blue
  },
  variables: {
    ...vuetifyStudioLightTheme.variables,
  },
};

export default {
  defaultTheme: 'livLight',
  themes: {
    livDark: vuetifyStudioDarkTheme,
    livLight: livLightTheme,
  },
  // variations: {
  //   colors: ['primary', 'secondary', 'tertiary'],
  //   lighten: 5,
  //   darken: 4,
  // },
};
